"use client";
import { QueueType, useGenerator } from "@/app/context/GeneratorContext";
import Image from "next/image";
import { useGlobalContext } from "@/app/context/store";
import PremiumComponent from "@/components/create/premiumComponent/premium";

export default function DisplayQueuing({ translations }: { translations: any }) {
  const { user } = useGlobalContext();
  const { state, generatingQueueType } = useGenerator();
  return (
    <>
      <div
        className={`px-auto flex h-[325px] w-full flex-col items-center justify-center border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] text-center sm:h-[50vh] sm:rounded-b-xl `}
      >
        <div className="my-auto flex flex-col items-center justify-center">
          <Image
            src={"https://cdn6.imgpog.com/loadingGIFlight.webp"}
            width={50}
            height={50}
            alt="Generating Image"
            className="m-auto mb-4"
            unoptimized
          />
          <div className="mx-5 flex flex-row font-medium text-white">
            <>
              {generatingQueueType === QueueType.Turbo ? (
                <div className="my-auto mr-1 rounded-md bg-[#FFCC18] px-1 text-sm font-semibold text-black">
                  {translations.turbo}
                </div>
              ) : (
                <div className="my-auto mr-1 rounded-md bg-[#fff] px-1 text-sm font-semibold text-[#202124]">
                  {translations.free}
                </div>
              )}
              <div className="ml-1 text-center">
                {state.queuePosition
                  ? translations.imageLoadingState1Title + state.queuePosition
                  : translations.queuePositionPending}
              </div>
            </>
          </div>
        </div>
        <div className="w-full rounded-xl p-4 text-center text-sm font-medium text-white">
          <div className="flex w-full">
            {(user.membership?.source === undefined ||
              user._id === "none" ||
              user.membership?.level === 0) && <PremiumComponent translations={translations} />}
          </div>
        </div>
      </div>
    </>
  );
}
